import { api, getCategories, getProjects } from "@";
import { searchValuesPayload } from "./helpers";
// Fetch detailed report data based on search criteria
export const getDetailedReport = (page = 1, perSize = null, search) => {
  return api.post(
    `/api/AdminOrder/latest-donations`,
    searchValuesPayload(page, perSize, search),
  );
};

// Fetch categories and projects data for search filters
export const getDetailedReportSearchData = () =>
  Promise.all([getCategories(), getProjects(1, null, null)]);

// export detailed report data based on search criteria (columns live in search)
export const exportDetailedReport = (page = 1, perSize = null, search) => {
  return api.post(
    `/api/AdminOrder/export-latest-donations`,
    searchValuesPayload(page, perSize, search),
    {
      responseType: "blob",
    },
  );
};

// Fetch available columns for the detailed report export
export const getExportColumns = () =>
  api.get(`/api/AdminOrder/export-latest-donations/columns`);